import { actions as parentActions } from '../../item';
import intl from '../../../shared/intl';
import translation from '../../../../config/translation';

const defaultInitialState = {
	isShow: false,
	formInitialValues: {
		closeMessage: 'The issue is resolved'
	}
};

const createCloseForm = ({
	namespace,
	stateNodeName
}) => {
	const TOGGLE_CLOSE_FORM = `${namespace}/${stateNodeName}-toggle-close-form`;

	// initState
	const initialState = {
		...defaultInitialState
	};

	// actions
	const actions = {
		toggleCloseForm: () => ({
			type: TOGGLE_CLOSE_FORM
		}),

		formSubmit: formData => (dispatch, getState) => {
			const { data: { ticket: { id } } } = getState()['extThreadsItem'];

			dispatch(parentActions.close([id], formData.closeMessage));
			dispatch(actions.toggleCloseForm());
		}
	};

	// reducers
	const reducers = {
		[TOGGLE_CLOSE_FORM]: state => ({
			...state,
			[stateNodeName]: {
				...state[stateNodeName],
				isShow: !state[stateNodeName].isShow
			}
		})
	};

	// selectors
	const selectors = {
		getInitialValues: state => {
			if (!state.extThreadsItem.language ) return;

			const translatorKey = state[namespace][stateNodeName].formInitialValues.closeMessage;
			const { extThreadsItem: { language } } = state;

			const closeMessage = (translation[translatorKey] && translation[translatorKey][language])
				? translation[translatorKey][language]
				: translatorKey;

			return {
				...state[namespace][stateNodeName].formInitialValues,
				closeMessage
			};
		},
		getShouldShowCloseFormStatus: state => state[namespace][stateNodeName].isShow,
		getCloseFormValidate: state => values => {
			const errors = [];
			const translator = intl(state);

			if (!values.closeMessage) {
				errors.closeMessage = translator('Message is required');
			}

			return errors;
		}
	};

	return {
		initialState,
		actions,
		reducers,
		selectors
	};
};

export default createCloseForm;



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/external-threads/components/close-form/index.js